import { render, staticRenderFns } from "./DMP_SPIP.vue?vue&type=template&id=c2e9ae40"
import script from "./DMP_SPIP.vue?vue&type=script&lang=js"
export * from "./DMP_SPIP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports